import { useEffect } from 'react';

import RecipeFloatingButtons from '../Member/components/recipe/RecipeFloatingButtons';
import { useFloatingButtonStore } from '../store/floatingButtonStore';
import { FloatingButtonType } from '../type';
import { useIsMajorPathname } from '../utils/hook/GNB';
import { usePathnameMethod } from '../utils/hook/usePathnameMethod';
import { CommunityPolicy } from '../utils/policy/CommunityPolicy';

const FloatingButton = () => {
  const floatingButton = useFloatingButtonStore.use.floatingButton();
  const setFloatingButton = useFloatingButtonStore.use.setFloatingButton();
  const {
    search,
    pathname,
    pathnameStartsWith,
    pathnameEndsWith,
    pathnameIncludes,
  } = usePathnameMethod();
  const { isDiaryDetailPage, isRecipeDetailPage } = useIsMajorPathname();

  useEffect(() => {
    if (
      pathnameStartsWith([
        '/ustore',
        '/gift/subscription',
        '/promotion',
        '/mypages/order-history',
        '/order-history',
        '/event',
        '/main',
        '/gift/cancel',
        '/gift/receive',
        '/buynow',
        '/passwords',
        '/reset-passwords',
        '/login',
        '/signup',
        '/recipes/diary/create',
        '/recipes/create',
        '/email/find',
        '/email/found',
        '/reviews/create',
        '/ad',
        '/referral',
        '/blogs',
      ]) ||
      pathnameIncludes([
        '/recipes/bookmark',
        '/delivery-schedule', // /subscriptions/506/delivery-schedule
        '/subscriptions/guest',
        'refrigerator',
        '/pause', // 정지페이지
        '/customize',
      ]) ||
      pathnameEndsWith([
        '/before-pause/3',
        '/review-contest-event',
        '/cancel/success',
        '/order-cancel/success',
      ]) ||
      (pathnameStartsWith('/recipes/') && pathnameEndsWith('/edit')) || // ex) /recipes/166/edit
      (pathnameStartsWith('/recipes/diary/') && pathnameEndsWith('/edit')) || // ex) /recipes/diary/137/edit
      (pathname === '/recipes' && search === '?search=true') ||
      pathname === '/benefit' ||
      isDiaryDetailPage ||
      isRecipeDetailPage ||
      /**
       * 마이페이지 하위 메뉴에서는 sticky 버튼 미노출
       * 단, 크리에이터 페이지(/mypages/creator)는 레시피 플로팅 버튼을 노출하므로 예외
       * @link https://www.notion.so/sticky-43857e7dacd04548821ba9245bdae518?pvs=4
       */
      (pathname !== '/mypages' &&
        pathname !== CommunityPolicy.CREATOR_PAGE_PATH &&
        pathnameStartsWith('/mypages/'))
    ) {
      setFloatingButton(FloatingButtonType.NULL);
    } else if (
      [
        '/recipes',
        '/recipes/diary',
        '/recipes/search',
        CommunityPolicy.CREATOR_PAGE_PATH,
      ].includes(pathname)
    ) {
      setFloatingButton(FloatingButtonType.RECIPE_CREATE);
    }

    return () => setFloatingButton(FloatingButtonType.NULL);
  }, [
    pathname,
    search,
    setFloatingButton,
    pathnameStartsWith,
    pathnameEndsWith,
    pathnameIncludes,
    isDiaryDetailPage,
    isRecipeDetailPage,
  ]);

  if (floatingButton === FloatingButtonType.RECIPE_CREATE) {
    return <RecipeFloatingButtons />;
  }

  return <></>;
};

export default FloatingButton;
